import { render } from "./PrizesPage.vue?vue&type=template&id=2751e24a&ts=true"
import script from "./PrizesPage.vue?vue&type=script&lang=ts"
export * from "./PrizesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Prizes/PrizesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2751e24a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2751e24a', __exports__)) {
    api.reload('2751e24a', __exports__)
  }
  
  module.hot.accept("./PrizesPage.vue?vue&type=template&id=2751e24a&ts=true", () => {
    api.rerender('2751e24a', render)
  })

}


export default __exports__